const setDispenseType = (state, payload) => {
  state.dispenseTypeLookup = payload;
};
const setDispenseBase = (state, payload) => {
  state.dispenseBaseLookup = payload;
};
const setUOM = (state, payload) => {
  state.UOMLookup = payload;
};
const setPackaging = (state, payload) => {
  state.packagingLookup = payload;
};

export default {
  setDispenseType,
  setDispenseBase,
  setUOM,
  setPackaging,
};
